var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Upload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 7.75C23.0175 7.75 16.74 13.8144 15.8623 21.5547C14.1741 21.8267 12.5908 22.5502 11.28 23.6484C9.96929 24.7467 8.97987 26.1789 8.4165 27.7934C3.65025 29.1671 0 33.418 0 38.75C0 45.1903 5.18475 50.375 11.625 50.375H50.375C56.8153 50.375 62 45.1903 62 38.75C62 35.34 60.3434 32.2865 57.9429 30.1514C57.4934 23.343 52.0626 17.9103 45.229 17.5576C42.8962 11.8827 37.5449 7.75 31 7.75ZM31 11.625C36.3514 11.625 40.6294 15.0544 42.1406 19.9175L42.5669 21.3125H44.5625C49.9003 21.3125 54.25 25.6622 54.25 31V31.9688L55.0366 32.5752C55.986 33.3028 56.7574 34.2368 57.2925 35.3066C57.8276 36.3764 58.1122 37.5539 58.125 38.75C58.125 43.1598 54.7848 46.5 50.375 46.5H11.625C7.21525 46.5 3.875 43.1598 3.875 38.75C3.875 34.8363 6.68438 31.7983 10.23 31.1821L11.5029 30.9399L11.7451 29.6651C12.3264 27.0553 14.6397 25.1875 17.4375 25.1875H19.375V23.25C19.375 16.7206 24.4706 11.625 31 11.625ZM31 22.4634L29.605 23.7944L21.855 31.5444L24.645 34.3344L29.0625 29.9092V42.625H32.9375V29.9092L37.355 34.3306L40.145 31.5406L32.395 23.7906L31 22.4634Z",
    fill: "#ED583B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Upload2);
export default __webpack_public_path__ + "static/media/icons8_upload-2.b02e6d41181980e7b2435b7f946c8eef.svg";
export { ForwardRef as ReactComponent };